import { postRequest } from "helpers/axios";
import { API_ROUTES } from "constants/apis";

const SetTemplateCoordinatesService = async (finalCoordData, uuid, tiUUID) => {
  try {
    const response = await postRequest(
      API_ROUTES.SET_COORDINATES_DATA_API_URL,
      true,
      {
        data: finalCoordData.map(({ writeBack, updateFromSalesforce, mappingField, ...rest }) => rest),
        documentUUID: uuid,
        docSignRequestUUID: tiUUID,
      }
    );

    if (response.status === 200) {
      return response;
    }

    throw new Error("Server returned a non-200 response when saving coordinates.");
  } catch (error) {
    throw new Error(
      error.message || "Something went wrong while saving coordinates to server."
    );
  }
};

export default SetTemplateCoordinatesService;
